import { BaseFoundationProject } from '@lfx/core/gql/services/inputs/base-foundation-project';

export interface FoundationProjectVulnerabilityInput
  extends BaseFoundationProject {
  offset: number;
  sortOrder: string;
  orderBy: string;
  limit: number;
}
